export const BREAK_POINT_WIDTH = 540;

export const BANNER_STYLES = "w-full object-cover h-[600px]";

export const CONTENT_STYLES =
    "absolute inset-0 flex flex-col items-center  text-center mt-[5%] lg:mt-[2%] justify-between px-4";

export const BANNER_CONTAINER = "relative";
